import { useMutation } from "redux-query-react";
import { deleteTenantPrivateBenchmarks } from "api/admin/src";
export const useDeleteTenantPrivateBenchmarks = (customQueryConfig) => useMutation((request, customQueryParam) => deleteTenantPrivateBenchmarks(request, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
